import { rootActions, useAppDispatch, useAppSelector } from '../DAL/store';
import {Popup} from "../../../ui/popup/popup";
import { useEffect, useRef } from 'react';

export const LoginPopup = () => {

    const dispatch = useAppDispatch();
    const isLoggedInForFreePlugin = useAppSelector(store => store.isLoggedInForFreePlugin);
    const popupDescription = isLoggedInForFreePlugin ? 'Please log in to your Waves account to select your free plugin' : 'Please log in to your Waves account to hide products you own';
    const btnRef = useRef<HTMLAnchorElement>(null);

    useEffect(() => {
        if(!btnRef || !btnRef.current) return;
        btnRef.current.focus();
    }, []);

    return (
        <Popup width="400px" height="270px" close={ () => {
            dispatch(
                rootActions.main({
                    showLoginPage: false
                })
            );
        }}>
            <div className="w-full h-full flex items-center justify-center">
                <div className="w-auto">
                    <p className="text-center pb-6">{popupDescription}</p>
                    <a
                       className="w-btn mx-auto w-fit"
                       ref={ btnRef }
                       href={ '/login?returnurl=' + encodeURIComponent(window.location.pathname )}
                       title="Log In Now">Log In Now</a>
                </div>
            </div>
        </Popup>
    )
};